export default {
  getCurrentStep: state => state.currentStep,
  getIsFiltering: state => state.isFiltering,
  getIsLoadingScreen: state => state.isLoadingScreen,
  getCategorieFilter: state => state.categorieFilter,
  getOfferFilter: state => state.offerFilter,
  getCampaignFilter: state => state.campaignFilter,
  getSvaFilter: state => state.svaFilter
}
